import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@boma/app-config';
import { IPaginatedResponse } from '@boma/client-shared';
import {
  ICreateFeedItem,
  IFeedItem,
} from 'libs/supplier-portal/shared/entities/src/lib/shared-entities';

@Injectable({
  providedIn: 'root',
})
export class FeedItemsService {
  private base: string;
  private version: string;

  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  loadFeedItems(
    entityId: string = '',
    type: string = '',
    page: string = '1',
    perPage: string = '150'
  ) {
    //console.log('Load feed items for EntityId: ' + entityId);
    return this.httpClient.get<IPaginatedResponse<IFeedItem>>(
      `${this.base}api/v${this.version}/${entityId}/FeedItems`,
      {
        params: { type, page, perPage },
      }
    );
  }

  uploadFeeItemImage(entityId, file) {
    let formData = new FormData();
    formData.append('file', file, file.name);
    return this.httpClient.post<string>(
      `${this.base}api/v${this.version}/${entityId}/FeedItems/UploadImage`,
      formData
    );
  }

  createFeeItem(entityId: string, data: ICreateFeedItem) {
    return this.httpClient.post<IFeedItem>(
      `${this.base}api/v${this.version}/${entityId}/FeedItems`,
      data
    );
  }

  updateFeedItem(entityId: string, id: string, data: ICreateFeedItem) {
    return this.httpClient.put<IFeedItem>(
      `${this.base}api/v${this.version}/${entityId}/FeedItems/${id}`,
      data
    );
  }
}
